import APIClient from '@/shared/http/clients/api'

const resourceName = 'grupoNotificacao'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const NotificationGroupRepository = {
  GetAll,
  GetById,
  Create,
  Update,
  Delete
}

export default NotificationGroupRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/notificationgroup.js